/**
 * The books (job costing, estimates, invoices) ship behind
 * `REACT_APP_BOOKS_ENABLED` so each lane merges to `main` as it goes
 * (plan §16.1). Unset or anything but `true` means off. `env` is for tests.
 */
export const booksEnabled = (env = process.env) =>
  env.REACT_APP_BOOKS_ENABLED === 'true';
